import axios from "axios";
import { authDeviceWithDomainHeader } from "../authServices/auth.header";
import { setMOH, setRecordings } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
class MediaSerices {
  // intent media file url generate
  async mediaFileUpload(data) {
    const response = await axios.post(
      API_URL + "pbx-service/media/upload",
      data,
      {
        headers: authDeviceWithDomainHeader(),
      }
    );
    return response.data;
  }

  //  RECORDING RELATED APIs

  // get Recording list
  async getRecordingList() {
    return await axios
      .get(API_URL + `call-app/media/recording`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add Recording
  async addRecording(data) {
    return await axios
      .post(API_URL + `call-app/media/recording`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setRecordings();
        return response.data;
      });
  }
  // delete Recording
  async deleteRecording(data) {
    return await axios
      .delete(API_URL + `call-app/media/recording`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setRecordings();
        return response.data;
      });
  }

  //  MUSIC ON HOLD RELATED APIs

  // get music on hold list
  async getMohList() {
    return await axios
      .get(API_URL + `call-app/media/moh`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add music on hold
  async addMoh(data) {
    return await axios
      .post(API_URL + `call-app/media/moh`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setMOH();
        return response.data;
      });
  }
  // update music on hold
  async updateMoh(id, data) {
    return await axios
      .patch(API_URL + `call-app/media/moh/` + id, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setMOH();
        return response.data;
      });
  }
  // delete music on hold
  async deleteMoh(data) {
    return await axios
      .delete(API_URL + `call-app/media/moh`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setMOH();
        return response.data;
      });
  }

  // Text to speech API
  async TTSEngine(data) {
    return await axios
      .post(API_URL + `pbx-service-child/text-to-speech`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Upload data to pre-signed URL
  async mediaFilePreSigned(URL, data, type, baseType) {
    try {
      const contentType = type;
      const response = await axios.put(URL, data, {
        headers: {
          "Content-Type": contentType,
        },
      });
      if (baseType === "moh") {
        setMOH();
      } else if (baseType === "recording") {
        setRecordings();
      }
      return response.data;
    } catch (error) {
      console.error("Error uploading media file:", error);
      throw error;
    }
  }
}

export default new MediaSerices();
